import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'

const Infos = ({ createdAt, campaign: { name } }) => (
  <div className='infos-content col-12 px-0'>
    <div className='row bg-white'>
      <div className='col-12 px-3 py-2'>
        <p className='mt-half  txt-subtitle'>
          Informações capturadas em {moment().format('DD/MM/YYYY')}, às{' '}
          {moment().format('HH:mm')} e sujeitas a alterações até o fim do dia.
        </p>
      </div>
    </div>
  </div>
)

Infos.propTypes = {
  createdAt: PropTypes.string.isRequired,
  campaign: PropTypes.shape({
    name: PropTypes.string.isRequired
  }).isRequired
}

export default Infos



// WEBPACK FOOTER //
// ./src/Participant/Extract/Infos/Infos.js